// extracted by mini-css-extract-plugin
export var readonly = "_bq-1";
export var star = "_bq-0";